#import "@/apollo/fragments/Annotation.gql"

mutation AddQAAnnotationOnComputedDeliverable(
    $campaignId: ID
    $computedDeliverableId: ID
    $computedDeliverableIdentifier: InputComputedDeliverableIdentifier
    $description: String!
    $timeline: Float!
    $xpos: Int!
    $ypos: Int!
    $mentions: [String]
) {
    addQAAnnotationOnComputedDeliverable(
        campaignId: $campaignId
        computedDeliverableId: $computedDeliverableId
        computedDeliverableIdentifier: $computedDeliverableIdentifier
        description: $description
        timeline: $timeline
        xpos: $xpos
        ypos: $ypos
        mentions: $mentions
    ) {
        ...Annotation
    }
}
